/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/prop-types */
import React from 'react';
import { useLocation } from '@reach/router';
import { navigate } from 'gatsby-link';
import { buildLink } from '../../../../utils/locale';
import { PBSLink } from '../../../atoms/link';
import { Button } from '../../../atoms/button';

function NewGluCard({ data, compact, locale }) {
	const location = useLocation();
	const isGluHW = location.pathname.includes('glu-health-and-wellbeing/');
	return (
		<div
			className={`flex flex-col rounded-[16px] glu-cards bg-white shadow-md mt-2 mb-10  grow ${
				compact ? 'w-full max-w-[250px]' : 'w-full'
			} h-auto pb-5 mx-auto`}
			// role="button"
			// tabIndex="0"
		>
			<div className="relative w-full group">
				<img
					src={
						data.thumbnail?.url ||
						'https://www.datocms-assets.com/64336/1686221516-5-glu-intro-blog.png'
					}
					alt={data.category?.title || 'Glu Intro'}
					className={`w-full h-[170px] object-cover rounded-t-[16px] transition-all duration-200 ${
						compact ? '' : 'max-w-[100%]'
					} group-hover:blur-[1px]`}
				/>
				{data.isNew && (
					<div className="absolute top-2 left-2 bg-brand-red-500/90 text-white text-xs  font-semibold px-3 py-1 rounded-md shadow-sm">
						New
					</div>
				)}

				<div className="absolute mr-2 pl-2 pr-2 pt-1 pb-1 rounded-md bg-brand-pale-400 text-black top-2 right-0 gap-1 inline-flex items-center">
					<div className="w-2 h-2 bg-blue-500 rounded-full" />
					<p className="text-xs">
						{data.category?.title || data.moreCategory?.title}
					</p>
				</div>
				<div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
					<PBSLink
						variant="Unset"
						className="bg-white/100 p-2 rounded-full shadow-lg"
						aria-label="Play Video"
						to={buildLink(
							locale,
							`/elearning/${
								data.category?.slug || data.moreCategory?.slug
							}/${data.slug}`
						)}
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							strokeWidth={2}
							stroke="currentColor"
							className="w-8 h-8 text-blue-400"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								d="M14.752 11.168l-5.197-3.07A1 1 0 008 9v6a1 1 0 001.555.832l5.197-3.07a1 1 0 000-1.664z"
							/>
						</svg>
					</PBSLink>
				</div>
			</div>
			<PBSLink
				className="flex flex-1 flex-col"
				variant="Unset"
				aria-label="Play Video"
				to={buildLink(
					locale,
					`/elearning/${
						data.category?.slug || data.moreCategory?.slug
					}/${data.slug}`
				)}
			>
				<div className="flex justify-between p-3 w-full items-center mt-2">
					<div className="w-10 h-10 gluxs:w-11 gluxs:h-11 glusm:w-12 glusm:h-12">
						<img
							src="https://www.datocms-assets.com/64336/1684148941-glu.svg"
							alt="glu logo"
							className="object-contain object-center"
						/>
					</div>
					{data.category?.slug === 'hr-and-employment-law' ? (
						<div className="text-left mt-0 text-xs">
							<p>
								<span className="text-success-500"> ✓ </span>
								CPD Accredited
							</p>
							<p>
								<span className="text-success-500"> ✓ </span>
								Certificate on completion
							</p>
							<p>
								<span className="text-success-500"> ✓ </span>
								1,000&apos;s completed
							</p>
						</div>
					) : (
						<div className="text-left gap-2 mt-0 text-xs">
							<p>
								<span className="text-success-500"> ✓ </span>
								Certificate on completion
							</p>
							<p>
								<span className="text-success-500"> ✓ </span>
								1,000&apos;s completed
							</p>
						</div>
					)}
				</div>
				<div className="font-lexend-bold flex-auto text-sm p-4">
					{data.title}

					<p className="mt-2 text-xs font-lexend-regular mb-2">
						{data.timeToWatchInMinutes
							? `${data.timeToWatchInMinutes} minutes`
							: ''}
					</p>
				</div>
				<div className="h-0.5 ml-4 w-[85%] items-center bg-grey-400/40 dark:bg-grey-400/40 rounded-l-md rounded-r-md" />
				{isGluHW && (
					<>
						<div className="flex p-3 text-sm gap-2">
							<p className="text-brand-red-500">
								{data.poweredByTitle}
							</p>
							<img
								src={data.logo?.url}
								className=" w-auto h-8 mr-3 "
								alt="Powered By Wisdom Wellbeing"
							/>
						</div>
					</>
				)}
				{/* <div className="w-[80%] h-auto ml-4  -mt-4 bg-grey-400/40 dark:bg-grey-400/40 rounded-l-md rounded-r-md">
					<div
						className="bg-blue-500 h-2 rounded-l-md rounded-r-md"
						style={{ width: `75%` }}
					/>
				</div> */}
			</PBSLink>

			<div className="px-4 mt-2">
				<Button
					variant="White"
					size="Small"
					className="w-full flex items-center justify-center gap-2"
					onClick={() => {
						navigate(
							buildLink(
								locale,
								`/elearning/${
									data.category?.slug || data.moreCategory?.slug
								}/${data.slug}`
							)
						);
					}}
				>
					<span className="text-sm">Start</span>
					{data.timeToWatchInMinutes && (
						// eslint-disable-next-line prettier/prettier
						<span className="text-sm text-blue-400 group-hover:text-white transition-colors"> - {data.timeToWatchInMinutes} minutes</span>
					)}
				</Button>
			</div>
		</div>
	);
}
export default NewGluCard;
